import React, { useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { useMediaQuery } from "react-responsive";
import axios from "axios";
import { API_BASE_URL, RECAPTCHA_SITE_KEY } from "@utils/constant";
import { SubmitHandler, useForm } from "react-hook-form";
import { Fade } from "react-awesome-reveal";
import ThankYou from "@pages/contact/parts/thank-you";
import { triggerEachFormTracker } from "@utils/helper";

const platformOptions = [
  {
    name: "Custom",
  },
  {
    name: "Magneto",
  },
  {
    name: "React Native",
  },
  {
    name: "Better Commerce",
  },
  {
    name: "Commerce",
  },
  {
    name: "Flutter",
  },
  {
    name: "Farzi Engineer",
  },
];

const supportlogo = [
  { id: 1, image: "/assets/images/migrate-ind/bsc.png" },
  { id: 2, image: "/assets/images/migrate-ind/levis.png" },
  { id: 3, image: "/assets/images/migrate-ind/libas.png" },
  { id: 4, image: "/assets/images/migrate-ind/plix.png" },
  { id: 5, image: "/assets/images/migrate-ind/foxtale.png" },
  { id: 6, image: "/assets/images/migrate-ind/rabbit.png" },
];

const brands = [
  {
    id: 1,
    image: "/assets/images/custom-checkout/converse.png",
    width: "120px",
    height: "auto",
  },
  {
    id: 2,
    image: "/assets/images/custom-checkout/mamaearth.png",
    width: "120px",
    height: "auto",
  },
  {
    id: 3,
    image: "/assets/images/custom-checkout/damensch.png",
    width: "120px",
    height: "auto",
  },
  {
    id: 4,
    image: "/assets/images/custom-checkout/beyoung.png",
    width: "120px",
    height: "auto",
  },
  {
    id: 5,
    image: "/assets/images/custom-checkout/dailyobj.png",
    width: "145px",
    height: "auto",
  },
  {
    id: 6,
    image: "/assets/images/custom-checkout/plix.png",
    width: "56px",
    height: "auto",
  },
  {
    id: 7,
    image: "/assets/images/custom-checkout/pepe.png",
    width: "100px",
    height: "auto",
  },
];

const SectionOne: React.FC<any> = () => {
  const params = new URLSearchParams(window.location.search);
  // export const SectionOne = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const recaptchaRef = React.useRef<ReCAPTCHA>();

  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    brand_url: "",
    g_recaptcha_token: "",
  });

  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const { handleSubmit, getValues } = useForm({});

  // const { data, params } = props;

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;

    // Allow only + and digits in mobile
    if (name === "mobile" && /[^\d+]/.test(value)) return;

    if (name === "daily_order") {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
        sub_platform: "",
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }

    // Clear error for field
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const validateForm = () => {
    const newErrors: typeof errors = {};
    if (!formData.name.trim()) newErrors.name = "Full name is required.";

    if (!formData.mobile.trim()) newErrors.mobile = "Phone number is required.";
    else if (!/^\+?\d{7,15}$/.test(formData.mobile.trim()))
      newErrors.mobile = "Enter a valid Phone number.";

    if (!formData.email.trim()) newErrors.email = "Email is required.";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email.trim()))
      newErrors.email = "Enter a valid email.";

    if (!formData.brand_url.trim()) {
      newErrors.brand_url = "Website URL is required.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleRecaptchaChange = (value) => {
    formData.g_recaptcha_token = value;
    // formData.daily_order = getValues("daily_order");
    // formData.sub_platform = getValues("sub_platform");
    axios
      .post(API_BASE_URL + "form/customCheckout", formData)
      .then(function (response) {
        setSuccessMessage("Demo booked successfully!");
        triggerEachFormTracker(formData);
        setFormData({
          name: formData.name,
          mobile: "",
          email: "",
          brand_url: "",
          g_recaptcha_token: "",
        });
      })
      .catch(function (error) {
        setLoading(false);
        console.log(error.response.data?.errors["product[]"]);
        setErrors(error?.response?.data?.errors);
      });
  };

  const handleRecaptchaSubmit = async () => {
    // Trigger the reCAPTCHA challenge
    recaptchaRef.current.execute();
  };

  const onSubmit: SubmitHandler<any> = async (data) => {
    // if (!data.product) {
    //   data.product = [];
    // }
    setSuccessMessage("");
    if (!validateForm()) return;

    data.source = params.get("utm_source");
    data.medium = params.get("utm_medium");
    data.campaign = params.get("utm_campaign");

    data.campaignid = params.get("campaignid");
    data.adgroupid = params.get("adgroupid");
    data.keyword = params.get("keyword");
    data.utm_term = params.get("utm_term");
    data.gad_source = params.get("gad_source");
    data.gad_campaignid = params.get("gad_campaignid");
    data.gbraid = params.get("gbraid");
    data.gclid = params.get("gclid");
    setFormData((prevData) => ({
      ...prevData,
      ...data,
    }));
    handleRecaptchaSubmit();
  };

  return (
    <div className="section-one-mirgate">
      <div
        className="section-mirgate"
        style={{ minHeight: isMobile ? "auto" : "100vh" }}
      >
        <div className="container-fluid" style={{ padding: "0 0px" }}>
          <div
            className="row banner align-items-center"
            style={{ padding: isMobile && "0 20px" }}
          >
            <div
              className="col-lg-7 col-md-12 banner-left"
              style={{ marginLeft: isMobile ? "0.2rem" : "4rem" }}
            >
              <img src="./assets/images/migrate-ind/kwik-engage-logo.png" alt="kwik-engage"  style={{maxWidth:'144px',height:'auto',marginBottom:"30px"}}/>
              <div className="heading-migrate">
                {!isMobile ? (
                  <h1
                    style={{
                      fontWeight: "500",
                      fontSize: "clamp(28px, 6vw, 56px)",
                      maxWidth: "625px",
                      marginTop: isMobile && "50px",
                    }}
                  >
                    Switch to a Marketing & Support CRM that drives 30% more
                    revenue
                  </h1>
                ) : (
                  <h1
                    style={{
                      fontWeight: "600",
                      fontSize: "clamp(28px, 6vw, 52px)",
                      marginTop: isMobile && "50px",
                    }}
                  >
                    Switch to a Marketing & Support CRM that drives 30% more
                    revenue
                  </h1>
                )}
                <p
                  style={{
                    fontWeight: "400",
                    fontSize: "clamp(16px, 6vw, 28px)",
                    marginTop: "25px",
                  }}
                >
                  and not just sends messages
                </p>
                <div className="brand-container-migrate">
                  <p>Join 15,000+ D2C Brands</p>
                  <div className="brand-logos">
                    {supportlogo.map((section) => (
                      <img
                        key={section.id}
                        className="brand-logo"
                        src={section.image}
                        alt={`support_logo_${section.id}`}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-12 banner-right mt-4 mt-lg-0">
              <div style={{ marginLeft: "50px" }}>
                <div
                  style={{ width: isMobile ? "90%" : "100%" }}
                >
                  <div className="form-container1-cc">
                    {successMessage && (
                      <Fade direction="right">
                        <ThankYou name={formData?.name} />
                      </Fade>
                    )}
                    {!successMessage && (
                      <form
                        className="demo-form1-migrate"
                        onSubmit={handleSubmit(onSubmit)}
                        noValidate
                      >
                        <input
                          type="text"
                          id="name"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          style={{
                            backgroundColor: "#eeeeee00",
                            border: "none",
                            borderRadius: "4px",
                            padding: "14px 16px",
                            fontSize: "14px",
                            width: "100%",
                            color: "#fff",
                            borderBottom:'1px solid black'
                          }}
                          placeholder="Full Name"
                        />
                        {errors.name && (
                          <p className="error" style={{ color: "red" }}>
                            {errors.name}
                          </p>
                        )}

                        <input
                          type="tel"
                          id="mobile"
                          name="mobile"
                          value={formData.mobile}
                          onChange={handleChange}
                          style={{
                            backgroundColor: "#eeeeee00",
                            border: "none",
                            borderRadius: "4px",
                            padding: "14px 16px",
                            fontSize: "14px",
                            width: "100%",
                            color: "#fff",
                            borderBottom:'1px solid black'

                          }}
                          placeholder="Phone Number"
                        />
                        {errors.mobile && (
                          <p className="error" style={{ color: "red" }}>
                            {errors.mobile}
                          </p>
                        )}

                        <input
                          type="email"
                          id="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          style={{
                            backgroundColor: "#eeeeee00",
                            border: "none",
                            borderRadius: "4px",
                            padding: "14px 16px",
                            fontSize: "14px",
                            width: "100%",
                            color: "#fff",
                            borderBottom:'1px solid black'

                          }}
                          placeholder="Email Id"
                        />
                        {errors.email && (
                          <p className="error" style={{ color: "red" }}>
                            {errors.email}
                          </p>
                        )}

                        <input
                          type="url"
                          id="brand_url"
                          name="brand_url"
                          value={formData.brand_url}
                          onChange={handleChange}
                          style={{
                            backgroundColor: "#eeeeee00",
                            border: "none",
                            borderRadius: "4px",
                            padding: "14px 16px",
                            fontSize: "14px",
                            width: "100%",
                            color: "#fff",
                            borderBottom:'1px solid black'

                          }}
                          placeholder="Ecommerce Store Link"
                        />
                        {errors.brand_url && (
                          <p className="error" style={{ color: "red" }}>
                            {errors.brand_url}
                          </p>
                        )}

                        <select
                          id="daily_order"
                          name="daily_order"
                          // value={formData.daily_order}
                          onChange={handleChange}
                          style={{
                            backgroundColor: "#eeeeee00",
                            border: "none",
                            padding: "14px 16px",
                            fontSize: "14px",
                            width: "100%",
                            color: "#000",
                            borderBottom:'1px solid black'

                          }}
                          placeholder="Type of eCommerce Platform"
                        >
                          <option value="" style={{ color: "#333" }}>
                            Type of eCommerce Platform
                          </option>
                          {platformOptions.map((opt) => (
                            <option
                              key={opt.name}
                              value={opt.name}
                              style={{ color: "#333" }}
                            >
                              {opt.name}
                            </option>
                          ))}
                        </select>
                        {errors.daily_order && (
                          <p className="error" style={{ color: "red" }}>
                            {errors.daily_order}
                          </p>
                        )}

                        <ReCAPTCHA
                          ref={recaptchaRef as React.RefObject<ReCAPTCHA>}
                          sitekey={RECAPTCHA_SITE_KEY}
                          size="invisible"
                          onChange={handleRecaptchaChange}
                        />

                        <button
                          type="submit"
                          disabled={loading}
                          style={{ borderRadius: "4px" }}
                        >
                          {loading ? "Submitting..." : "Book a Demo"}
                        </button>
                        {successMessage && (
                          <p className="success">{successMessage}</p>
                        )}
                      </form>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <div className="brand-top">
            <p>Powering India's top brands on their custom tech stack</p>

            {isMobile ? (
              // ✅ Mobile: Scrolling loop
              <div className="support-logos-wrapper">
                <div className="support-logos-track">
                  {brands.concat(brands).map((section, idx) => (
                    <img
                      key={`${section.id}-${idx}`}
                      className="support-logo-brand"
                      src={section.image}
                      alt={`support_logo_${section.id}`}
                      style={{ width: section.width, height: section.height }}
                    />
                  ))}
                </div>
              </div>
            ) : (
              // ✅ Desktop: Static grid/flex
              <div className="support-logos">
                {brands.map((section) => (
                  <img
                    key={section.id}
                    className="support-logo-brand"
                    src={section.image}
                    alt={`support_logo_${section.id}`}
                    style={{ width: section.width, height: section.height }}
                  />
                ))}
              </div>
            )}
          </div> */}
        </div>
      </div>
    </div>
  );
};
export default SectionOne;
